import { Row } from 'antd';
import styled from 'styled-components';

import loginBg from '../../assets/images/login-bg.png';

export const BackgroundLogin = styled(Row)`
  height: 100vh;
  background-image: ${`url(${loginBg})`};
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ContainerLogin = styled.div`
  position: absolute;
  width: 360px;
`;

export const WrapperForm = styled.div`
  margin-top: 25px;
`;
